import React from "react";

export const DateTimeDisplay = ({ value, type, isDanger }) => {
    return (
        <div className={isDanger? 'countdown danger' : 'countdown'}>
            <p>{value}</p>
            <span>{type}</span>
        </div>
    )
}